var React = require('react');

function ReturnInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("title",{"key":1},"return.inline"),React.createElement("path",{"className":"a","d":"M11,2.11A6.95,6.95,0,1,1,11,16H3.56V13.05H11a4,4,0,1,0,0-8H6.23V7.16L0,3.58,6.23,0V2.11Z","key":2})]);
}

ReturnInline.defaultProps = {"viewBox":"0 0 18 16"};

module.exports = ReturnInline;

ReturnInline.default = ReturnInline;
